/**
 * Where the signed-in person can work: the platform and their own accounts.
 * The server decides; moving reloads the app so nothing cached from the
 * previous scope stays on screen.
 */
import { useQuery } from "@tanstack/react-query";

import { readScopes, switchScope, type ScopeOption } from "@/shared/api";

export const SCOPES_KEY = ["auth-scopes"] as const;

export function useScopes(): readonly ScopeOption[] {
  const query = useQuery({
    queryKey: SCOPES_KEY,
    retry: false,
    staleTime: 60_000,
    queryFn: async () => {
      const { data } = await readScopes();
      return data?.options ?? [];
    },
  });
  return query.data ?? [];
}

export async function moveTo(option: ScopeOption): Promise<boolean> {
  const { response } = await switchScope({
    body: { tenant_id: option.tenant_id, account_id: option.account_id },
  });
  if (response?.status !== 204) return false;
  window.location.assign(option.kind === "PLATFORM" ? "/app/clients" : "/app");
  return true;
}
